import { useEffect, useState } from "react";
import "./style.css";

function CustomTextArea({ value, onChange, name, ...rest }) {

    const [val, setVal] = useState(value);

    useEffect(() => {
        setVal(v => value);
    }, [value]);

    return (
        <div id="custom-textarea" >

            <pre className="prompt-pre" contentEditable={true} onInput={(e) => {
                setVal(e.target.innerText);
                onChange({
                    target: {
                        value: e.target.innerText,
                        name: name,
                    }
                });
            }}>
                {value}
            </pre>
        </div>
    );
}

export default CustomTextArea;